import React from 'react';
import { useTranslate } from 'react-admin';
import { Link, useLocation } from 'react-router-dom';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Fab from '@mui/material/Fab';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import time_entries from '../time_entries';
import weeklies from '../weeklies';
import leaves from '../leaves';

const sx = { position: 'fixed', bottom: 16, right: 16 };

const CustomSpeedDial = () => {
    const { pathname } = useLocation();
    const translate = useTranslate();
    const settings = localStorage.getItem('speedDialSettings') ? JSON.parse(localStorage.getItem('speedDialSettings')) : null;

    if (settings?.show === 'disabled' || ((!settings?.show || settings?.show === 'dashboard') && pathname !== '/')) {
        return null;
    }

    const actions = [
        { id: 'timesheet_create', icon: <time_entries.icon />, name: translate('Timesheet'), to: '/time_entries/create' },
        { id: 'timesheet_stats', icon: <QueryStatsIcon />, name: translate('Timesheet stats'), to: '/time_entries/stats' },
        { id: 'timesheet_calendar', icon: <CalendarMonthIcon />, name: translate('Timesheet calendar'), to: '/time_entries/calendar' },
        { id: 'weekly_create', icon: <weeklies.icon />, name: translate('Weekly'), to: '/weeklies/create' },
        { id: 'leaves_create', icon: <leaves.icon />, name: translate('Leaves'), to: '/leaves/create' },
    ];

    if (!settings?.actions || settings?.actions?.length === 0 || settings?.actions?.length === 1) {
        const action = settings?.actions ? actions.find(a => a.id === settings?.actions[0]?.action) : actions.find(a => a.id === 'timesheet_create');

        if (!action) {
            return null;
        }

        return (
            <Fab color="primary" sx={sx} component={Link} to={action?.to}>
                {action.icon ? action.icon : <time_entries.icon />}
            </Fab>
        );
    }

    return (
        <SpeedDial
            ariaLabel="Speed Dial"
            sx={sx}
            icon={<SpeedDialIcon />}
        >
            {settings?.actions.map((item) => {
                const action = actions.find(a => a.id === item.action);
                if (!action || !item?.action) {
                    return null;
                }
                return (
                    <SpeedDialAction
                        component={Link}
                        to={action?.to}
                        key={action?.name}
                        icon={action?.icon}
                        slotProps={{
                            tooltip: {
                                title: action?.name,
                            }
                        }}
                    />
                );
            })}
        </SpeedDial>
    );
};

export default CustomSpeedDial;
